export default {
  Purchase_advise: '采购建议',
  Out_of_stock_Qty: '缺货量',
  Advised_purchase_Qty: '建议采购量',
  SKU_no: 'sku编码',
  SKU_name: 'sku名称',
  SPU_no: 'spu编码',
  SPU_name: 'spu名称',
  Supplier: '供应商',
  SKU_Status: 'sku活跃度',
  Purchase_strategy: '采购策略',
  Batch_Search: '批量搜索',
  System_order_no: '系统订单号',
  SKU_info: '货品信息',
  Category: '分类',
  Brand: '品牌',
  Purchase_order_info: '采购信息',
  Warehouse: '仓库',
  Current_stock: '当前库存数',
  Available_stock: '可发库存数',
  Purchase_in_transit: '采购在途',
  EST_days_available: '预计可发天数',
  EST_stock_available: '预计可用库存数',
  Operation_info: '运营信息',
  Out_of_stock_order_no: '缺货订单',
  Not_on_due: '不临期',
  On_due: '临期',
  Image: '图片',
  Bar_code: '条形码',
  Non_arrived_Qty: '采购未到货量',
  Non_stock_in_Qty: '采购到货未入库量',
  Return_in_transit: '销退在途量',
  Preparation_time: '备货时长',
  Out_of_stock_in_X_days: '缺货日期',
  Out_of_stock_order_Qty: '缺货量',
  seven_day_sales_average_total: '7天销量（日均/总量）',
  fourteen_day_sales_average_total: '14天销量（日均/总量）',
  thirty_day_sales_average_total: '30天销量（日均/总量）',
  Sales_trend: '销量趋势',
  EST_daily_sales: '测算日销',
  Refresh_time: '建议更新时间',
  Operation: '操作',
  New_purchase_plan: '生成采购计划',
  New_purchase_order: '生成采购单',
  Set_advise_strategy: '设置建议策略',
  Refresh: '更新建议',
  Customised_search_setting: '筛选项配置',
  Set_SKU_status: '设置SKU活跃度',
  Set_sales_trend_rules: '设置销量趋势规则',
  Download: 'Download',
  Hot: '爆款',
  Dump: '滞销款',
  New: '新品',
  Priority: '优先级',
  Time: '时间',
  recent_N_days: '最近N天',
  Sales_range: '销售区间',
  Stock_range: 'Stock range',
  SKU_new_N_days_are_NEW: 'SKU创建时间 N 天内定义为新品',
  Enable_status: '启用状态',
  Sales_trend_tip1: '销量趋势是依据最近7天的日销量变化，拟合1条斜线的斜率作为趋势值',
  Sales_trend_tip2: 'X轴的单位长度影响销量趋势值的准确性',
  Sales_trend_tip3: '通过该入口批量设置X轴单位长度，也可以设置某一条数据的X轴单位长度'

}
